/**
 * Main Layout Component
 * Portal-wide layout with sidebar, header, and content area
 */

import { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { PortalSidebar } from './PortalSidebar';
import { PortalHeader } from './PortalHeader';
import { CommandPalette, KeyboardShortcuts } from '../Common';
import { getUserSettings, updateUserSettings } from '../../db';

export function MainLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const location = useLocation();

  // Load sidebar state from settings
  useEffect(() => {
    getUserSettings().then(settings => {
      setSidebarCollapsed(settings.sidebarCollapsed);
    });
  }, []);

  const handleToggleSidebar = async () => {
    const newState = !sidebarCollapsed;
    setSidebarCollapsed(newState);
    await updateUserSettings({ sidebarCollapsed: newState });
  };

  // Check if we're in a project workspace (needs full width)
  const isWorkspace = location.pathname.includes('/projects/') && 
                      location.pathname.split('/').length > 2;

  return (
    <div className="h-screen flex bg-slate-100 dark:bg-slate-900 transition-colors">
      {/* Sidebar */}
      <PortalSidebar 
        collapsed={sidebarCollapsed} 
        onToggle={handleToggleSidebar}
      />

      {/* Main content area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <PortalHeader onToggleSidebar={handleToggleSidebar} />

        {/* Page content */}
        <main className={`flex-1 overflow-auto dark-scrollbar ${isWorkspace ? '' : 'dashboard-grid-bg dark:dashboard-grid-bg-dark'}`}>
          <Outlet />
        </main>
      </div>

      {/* Global Command Palette */}
      <CommandPalette />
      
      {/* Keyboard Shortcuts Help */}
      <KeyboardShortcuts />
    </div>
  );
}
